import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import OrderConfirmation from "@/pages/OrderConfirmation";
import AdminPanel from "@/pages/AdminPanel";
import GroupOrderPage from "@/pages/GroupOrderPage";
import CompanyInfo from "@/pages/CompanyInfo";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AllergensInfo from "@/pages/AllergensInfo";
import LoginPage from "@/pages/LoginPage";
import MyAccountPage from "@/pages/MyAccountPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/CookieConsent";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/group-order/:groupOrderId" element={<GroupOrderPage />} />
            <Route path="/company-info" element={<CompanyInfo />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/allergens" element={<AllergensInfo />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/my-account" element={<MyAccountPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;